import React from 'react'
import Header from './header'
import Footer from './Footer'
import Newsletter from './HomeNewsletter'
import { Section } from 'lucide-react'
import CustomerHeader from '../customer/CustomerHeader'
import { useCustomerAuth } from '../../contexts/CustomerAuthContext'

function Blog() {
  const { isAuthenticated } = useCustomerAuth();
  return (
    <div>
            {isAuthenticated ? <CustomerHeader /> : <Header />}

                <section className='blog-page'>
                     
  <div className="container my-5">
    <div className="row">
     
      <div className="col-md-9">
        <div className="row gap-y-6">
         
          <div className="col-md-4">
            <div className="card blog-card">
            <img className="service-image" width="400" height="262" alt="" src="/assets/images/service-one.png"/>
              <div className="card-body">
                <h5 className="card-title">Blog Post Title</h5>
                <p className="card-text">Short description of the blog post goes here. It should entice users to read more.</p>
                <a href="#" className="cm-btn">Read More</a>
              </div>
            </div>
          </div>

        
         <div className="col-md-4">
            <div className="card blog-card">
              <img className="service-image" width="400" height="262" alt="" src="/assets/images/service-one.png"/>
              <div className="card-body">
                <h5 className="card-title">Another Blog Title</h5>
                <p className="card-text">Another short description of a different blog article goes here.</p>
                <a href="#" className="cm-btn">Read More</a>
              </div>
            </div>
          </div>
            <div className="col-md-4">
            <div className="card blog-card">
              <img className="service-image" width="400" height="262" alt="" src="/assets/images/service-one.png"/>
              <div className="card-body">
                <h5 className="card-title">Another Blog Title</h5>
                <p className="card-text">Another short description of a different blog article goes here.</p>
                <a href="#" className="cm-btn">Read More</a>
              </div>
            </div>
          </div>
            <div className="col-md-4">
            <div className="card blog-card">
              <img className="service-image" width="400" height="262" alt="" src="/assets/images/service-one.png"/>
              <div className="card-body">
                <h5 className="card-title">Another Blog Title</h5>
                <p className="card-text">Another short description of a different blog article goes here.</p>
                <a href="#" className="cm-btn">Read More</a>
              </div>
            </div>
          </div>
             <div className="col-md-4">
            <div className="card blog-card">
              <img className="service-image" width="400" height="262" alt="" src="/assets/images/service-one.png"/>
              <div className="card-body">
                <h5 className="card-title">Another Blog Title</h5>
                <p className="card-text">Another short description of a different blog article goes here.</p>
                <a href="#" className="cm-btn">Read More</a>
              </div>
            </div>
          </div>
             <div className="col-md-4">
            <div className="card blog-card">
              <img className="service-image" width="400" height="262" alt="" src="/assets/images/service-one.png"/>
              <div className="card-body">
                <h5 className="card-title">Another Blog Title</h5>
                <p className="card-text">Another short description of a different blog article goes here.</p>
                <a href="#" className="cm-btn">Read More</a>
              </div>
            </div>
          </div>

        
        </div>
      </div>

     
      <div className="col-md-3">
        <div className="sidebar">
         
          <div className="mb-4">
            <h5>Search</h5>
            <form>
              <div className="input-group">
                <input type="text" className="form-control" placeholder="Search..."/>
                <button className="btn btn-primary" type="submit">Go</button>
              </div>
            </form>
          </div>

       
          <div className="mb-4">
            <h5>Categories</h5>
            <div className="list-group">
              <a href="#" className="list-group-item list-group-item-action">Technology</a>
              <a href="#" className="list-group-item list-group-item-action">Lifestyle</a>
              <a href="#" className="list-group-item list-group-item-action">Design</a>
              <a href="#" className="list-group-item list-group-item-action">Travel</a>
            </div>
          </div>

          <div>
            <h5>Recent Posts</h5>
            <ul className="list-unstyled">
              <li><a href="#" className="text-decoration-none">How to Design a Great Website</a></li>
              <li><a href="#" className="text-decoration-none">Top 10 Travel Destinations</a></li>
              <li><a href="#" className="text-decoration-none">Tips for Remote Work</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
                </section>
            <Newsletter/>
            <Footer/>
    </div>
  )
}

export default Blog
